import { ArdoqId } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import { includeComponentFromGraphClicked } from 'appContainer/MainAppModule/MainAppModuleSidebar/scenarioRelated/navigator/actionWrappers';

export const includeComponentIntoActiveScenario = (
  componentId: ArdoqId
): void => {
  dispatchAction(includeComponentFromGraphClicked({ componentId }));
};
